import React from 'react';
import './SideBarTabContainer.css';

const SideBarTabContainer = (props) => (<ul className="sidebar-tab--container list-group">{props.children}</ul>);

export default SideBarTabContainer;
